import React, { ButtonHTMLAttributes } from "react";
import { StyledButton } from "./Button.styled";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { IconManager } from "../IconManager/IconManager";
import { ButtonTypography } from "../../Typography/ButtonTypography/ButtonTypography";
import { theme } from "../../../constants/StyledComponents";

export enum ButtonVariants {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum ButtonSizes {
  REGULAR = "regular",
  SMALL = "small",
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  variant?: ButtonVariants;
  size?: ButtonSizes;
  icon?: React.JSX.Element;
  sizeIcon?: IconSizeEnum;
  $fullwidth?: boolean;
}

export const Button = ({
  label,
  variant = ButtonVariants.PRIMARY,
  size = ButtonSizes.REGULAR,
  icon,
  sizeIcon = size === ButtonSizes.REGULAR
    ? IconSizeEnum.SMALL
    : IconSizeEnum.XSMALL,
  $fullwidth,
  ...props
}: ButtonProps) => {
  const getIconColor = () => {
    if (props.disabled) {
      return theme.colors.grey_2;
    }
    if (variant === ButtonVariants.PRIMARY) {
      return theme.colors.white;
    }
    return theme.colors.black;
  };

  return (
    <StyledButton
      $variant={variant}
      $size={size}
      $fullwidth={$fullwidth}
      {...props}
    >
      {icon && (
        <IconManager
          size={sizeIcon}
          marginRight={label ? 8 : 0}
          color={getIconColor()}
        >
          {icon}
        </IconManager>
      )}
      {label ? (
        <ButtonTypography fontWeight={FontWeightEnum.MEDIUM}>
          {label}
        </ButtonTypography>
      ) : null}
    </StyledButton>
  );
};
